
/**
 *  报到返回键事件,告诉手机需要调用返回键
 * @since 1.0.0
 * @returns 返回状态信息
 * @example
 * 
 * needBackAction()
 */
function needBackAction() {
    return new Promise((resolve) => {
        window.WebViewJavascriptBridge.callHandler('needBackAction', {}, response => {
            resolve(response)
        })
    })
}

export default needBackAction